<template lang="pug">
  #admin-super-member-center
    WtTile(ancestor)
      WtTile(vertical)
        WtTile(parent)
          WtTile(child :col="12")
            button.button(@click="cacheBuster") Cache Buster

      WtTile(vertical)
        WtTile(parent)
          WtTile(child :col="12")
            button.button(@click="openModal") Upload Member Delete Feed

    WtTile(:col="12")
      WtTile(vertical :col="12")
        WtTile.members-list-title(
          child
          :col="12"
          :is-loading="!membersLoaded && membersInitialLoadComplete"
        )
          MemberList(
            :member-response-object="adminMembersResponseObject"
            :initial-load-complete="membersInitialLoadComplete"
            :fetch-action="fetchProgramMembers"
            :show-program-column="true"
            :super-admin-member-list="true"
            @search="onSearch($event)"
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import EmailTemplatesTable from "@@/MemberCenterAdminSuper/EmailTemplatesTable";
import MemberList from "@@/MemberCenterAdmin/MemberList";

const SuperAdminMemberDeleteFeed = () =>
  import(
    /* webpackChunkName: "SuperAdminMemberDeleteFeed" */ "@@/SuperAdminDeleteQueue/SuperAdminMemberDeleteFeed"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "AdminSuperMemberCenter",

  components: { WtTile, EmailTemplatesTable, MemberList },

  data() {
    return {
      templates: [],
      templatesLoading: false,
      searchQuery: "",
      perPage: 5
    };
  },

  // mounted() {
  //   this.fetchEmailTemplates();
  // },

  computed: {
    ...mapGetters("program", [
      "adminMembersResponseObject",
      "membersLoaded",
      "membersInitialLoadComplete"
    ])
  },

  mounted() {
    this.fetchProgramMembers({});

    this.onSearch = this._.debounce(async query => {
      this.searchQuery = query;
      const response = await this.searchMembers({
        programId: this.$auth.user().programId,
        query,
        perPage: this.perPage,
        includeMember: "allPrograms"
      });

      this.setAdminMembersResponseObject(response);
    }, 500);
  },

  methods: {
    ...mapActions("program", [
      "fetchMembers",
      "searchMembers",
      "setAdminMembersResponseObject"
    ]),
    ...mapActions("emailTemplates", [
      "fetchTemplates",
      "storeTemplate",
      "deleteTemplate",
      "updateTemplate"
    ]),

    async fetchEmailTemplates() {
      this.templatesLoading = true;
      this.templates = await this.fetchTemplates();
      this.templatesLoading = false;
    },

    fetchProgramMembers(payload) {
      Object.assign(payload, {
        programId: this.$auth.user().programId,
        perPage: this.perPage,
        includeMember: "allPrograms"
      });

      if (this.searchQuery) {
        payload.query = this.searchQuery;
        return this.searchMembers(payload).then(response => {
          this.setAdminMembersResponseObject(response);
          return response;
        });
      }

      return this.fetchMembers(payload);
    },

    openModal() {
      this.$buefy.modal.open({
        parent: this,
        component: SuperAdminMemberDeleteFeed,
        hasModalCard: true
      });
    },

    cacheBuster() {
      this.$buefy.dialog.confirm({
        title: "for emergency use only",
        confirmText: "Yes",
        type: "is-danger",
        hasIcon: true,
        message: "are you sure you wish to do this?",
        onConfirm: async () => {
          this.axios
            .get(`cache-buster`)
            .then(response => {
              if (response && response.data.success) {
                this.$buefy.toast.open("CACHE BUSTED!");
              }
              console.log("response: ", response);
            })
            .catch(error => {
              this.$buefy.toast.open("try again...");
              console.log("error: ", error);
            });
        }
      });
    },

    onSearch() {
      // overwritten in mounted so debounce has access to component instance
    }
  }
};
</script>

<style lang="sass" scoped>
#admin-super-member-center
  .members-list-title
    min-height: 300px
</style>
